import FlexStack from "../../components/Common/flex-stack";
import {Widget} from "../../components/Common";
import React, {PropsWithChildren, useState} from "react";
import {Alert, Button, Chip, Stack, Typography} from "@mui/material";
// import {Chip, TableContainer} from "@mui/material";
// import {DataTable} from "../../components/Table/data-table";
import {InfoBox, WarningBox} from "../../components/Common/alerts";
import {OpenInNew} from "@mui/icons-material";
// import {Done} from "@mui/icons-material";
import {useSubscription} from "../../hooks/use-subscription";
// import {useSubscription, useSubscriptionHistory} from "../../hooks/use-subscription";
import {SubscriptionType, SubscriptionTypeValues} from "../../api/generated/herds-licensing";
// import {SubscriptionsTestApi, SubscriptionType, SubscriptionTypeValues} from "../../api/generated/herds-licensing";
import FormattedDate from "../../components/Common/formatted-date";
import {getDurationDays} from "../../components/AnimalDashboard/Pregnancy/pregnancy-utils";
import {DateTime} from "luxon";
// import {useQuery} from "@tanstack/react-query";
// import ApiConfig from "../../api/config/api-config";
import {useOwnBreederDetails} from "../../hooks/use-breeders";
// import {useBreederInfo, useOwnBreederDetails} from "../../hooks/use-breeders";
import {Subscription} from "../../services/subscription-service";
import {PaymentService} from "../../services/payment-service";
import {useTranslation} from "react-i18next";
import {ResumeCheckout} from "../../components/Subscription/resume-checkout";
import {canResumeCheckout} from "../../components/Subscription/resume-checkout-visibility";
import {getSubscriptionStatuses} from "../../components/Subscription/subscription-status";
import {usePaymentStatus} from "../../hooks/use-payment-status";

const FlexWidget = (props: PropsWithChildren<{ displayName: React.ReactNode }>) => (
    <Widget displayName={props.displayName}>
        <FlexStack>
            {props.children}
        </FlexStack>
    </Widget>
);


// const InvoiceWidget = () => {
//     const invoices = [{
//         period: 'Testphase',
//         amount: '0,00 €',
//         status: <Chip icon={<Done/>} size="small" color="success" variant="outlined" label="Bezahlt"/>,
//         document: '---',
//     }];
//
//     return (
//         <FlexWidget displayName="Rechnungen">
//             <TableContainer>
//                 <DataTable data={invoices} columns={[
//                     {id: 'period', header: 'Zeitraum', accessor: 'period'},
//                     {id: 'amount', header: 'Betrag', accessor: 'amount'},
//                     {id: 'status', header: 'Status', accessor: 'status'},
//                     {id: 'document', header: 'Dokument', accessor: 'document'},
//                 ]}/>
//             </TableContainer>
//         </FlexWidget>
//     );
// };
//
// // TODO remove after successful tests
// const subscriptionsTestApi = new SubscriptionsTestApi(new ApiConfig());
// const SubscriptionTestingWidget = () => {
//     const {data: breederInfo} = useBreederInfo();
//     const {history = []} = useSubscriptionHistory(breederInfo.id);
//     const activeQuery = useQuery({
//         queryKey: ['subscription', 'test', 'active'],
//         queryFn: async () => await subscriptionsTestApi.testActive(),
//     });
//     const expiredQuery = useQuery({
//         queryKey: ['subscription', 'test', 'expired'],
//         queryFn: async () => await subscriptionsTestApi.testExpired(),
//     });
//
//     return (
//         <FlexWidget displayName="Testing">
//             <div>Active: {activeQuery.data} ({activeQuery.isLoading ? 'loading...' : (activeQuery.isError && '!!!')})</div>
//             <div>Expired: {expiredQuery.data} ({expiredQuery.isLoading ? 'loading...' : (expiredQuery.isError && '!!!')})</div>
//             <div>
//                 <h3>History</h3>
//                 <ol>
//                     {history.map(log => (<li>{log}</li>))}
//                 </ol>
//             </div>
//         </FlexWidget>
//     );
// }

const subscriptionTypeText = (type: SubscriptionType) => {
    switch (type) {
        case SubscriptionTypeValues.TRIAL:
            return 'Testphase';
        case SubscriptionTypeValues.INDIVIDUAL:
            return 'Einzelabo';
        default:
            return 'Abo';
    }
};

const StatusChips = ({subscription, creemActive}: { subscription: Subscription, creemActive: boolean }) => {
    const {t, i18n} = useTranslation();
    const statuses = getSubscriptionStatuses({subscription, creemActive});
    const isExpired = statuses.includes('expired');

    return (
        <Stack direction="row" gap={1} flexWrap="wrap">
            {statuses.map(status => {
                switch (status) {
                    case 'expired':
                        return <Chip key={status} size="small" color="error" label={t('subscription.status.expired')}/>;
                    case 'cancelled':
                        return <Chip key={status} size="small" color="error" variant={isExpired ? 'outlined' : 'filled'}
                                     label={t('subscription.status.cancelled')}/>;
                    case 'cancelledAtEnd':
                        return <Chip key={status} size="small" color="warning"
                                     label={t('subscription.status.cancelledAtEnd')}/>;
                    case 'trial':
                        return <Chip key={status} size="small" color="info"
                                     label={t('subscription.status.trial', {
                                         date: subscription.expiresAt.setLocale(i18n.language).toLocaleString(DateTime.DATE_MED)
                                     })}/>;
                    case 'active':
                        return <Chip key={status} size="small" color="success"
                                     label={t(creemActive ? 'subscription.status.activeRenewing' : 'subscription.status.active')}/>;
                }
                return null;
            })}
        </Stack>
    );
};

const CurrentSubscription = ({subscription, creemActive}: { subscription: Subscription, creemActive: boolean }) => {
    const {expiresAt, isExpired} = subscription;
    return (
        <>
            <Stack direction="row" gap={1.5} alignItems="center" flexWrap="wrap">
                <Typography variant="subtitle1">{subscriptionTypeText(subscription.type)}</Typography>
                <StatusChips subscription={subscription} creemActive={creemActive}/>
            </Stack>
            <Typography variant="body2" color="textSecondary">
                {isExpired ? (
                    <>
                        Am <FormattedDate date={expiresAt}/> abgelaufen
                        (vor {getDurationDays({start: expiresAt, end: DateTime.now()})} Tagen)
                    </>
                ) : (
                    <>
                        Gültig bis: <FormattedDate date={expiresAt}/> ({getDurationDays({
                        start: DateTime.now(),
                        end: expiresAt
                    })} Tage verbleibend)
                    </>
                )}
            </Typography>
        </>
    );
};

const CustomerPortalButton = () => {
    const {t} = useTranslation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const openCustomerPortal = async () => {
        setError(null);
        // open the tab synchronously (on click) so that popup blockers don't interfere
        const newTab = window.open('about:blank', '_blank');
        if (newTab) {
            newTab.opener = null;
        }
        setLoading(true);
        try {
            const link = await PaymentService.customerPortalLink();
            if (newTab) {
                newTab.location.href = link;
            } else {
                window.open(link, '_blank', 'noopener,noreferrer');
            }
        } catch (e) {
            newTab?.close();
            setError(t('subscription.customerPortal.openError'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <Stack spacing={0.5} alignItems="flex-start">
            <Button variant="outlined" endIcon={<OpenInNew/>} disabled={loading} onClick={openCustomerPortal}>
                {t('subscription.customerPortal.open')}
            </Button>
            <Typography variant="caption" color="textSecondary">
                {t('subscription.customerPortal.hint')}
            </Typography>
            {error && <Alert severity="error" onClose={() => setError(null)}>{error}</Alert>}
        </Stack>
    );
};

export const SubscriptionOverviewPage = () => {
    const {t} = useTranslation();
    const {subscription} = useSubscription();
    const {ownDetails} = useOwnBreederDetails();
    const {paymentStatus} = usePaymentStatus();

//     const cancelSubscription = () => {
//         if (window.confirm(`Das Abo bleibt bis XXXX aktiv. Danach steht das Konto noch weitere 90 Tage im Lesemodus zur Verfügung.
// Du erhältst unmittelbar eine E-Mail-Bestätigung. Rechnungen & Datenexport findest du im Abo-Center.
//
// Wirklich kündigen?`)) {
//             window.alert('Abo erfolgreich gekündigt.');
//         }
//     };

    // const changeSubscription = () => window.alert("Coming soon.");
    // const changePaymentMode = () => window.alert("Coming soon.");

    const isRegistryMember = !!ownDetails.registries?.memberOf.length;
    // undefined while the Creem status is still loading (or failed to load)
    const creemActive = paymentStatus?.creemActive;
    const showCustomerPortal = !!subscription && !!paymentStatus?.creemCustomer && !isRegistryMember;
    const isTrialResume = !!subscription && !subscription.isExpired;
    // the last payment failed, access is unchanged until the paid period ends
    const showPastDue = showCustomerPortal && !!paymentStatus?.pastDue;


    return (
        <FlexStack>
            <FlexWidget displayName="Aktueller Plan">

                {/*<InfoBox>Testphase aktiv bis 26.10.2025. Bis dahin wird nichts abgebucht.</InfoBox>*/}

                {/*<TableContainer>*/}
                {/*    <Table size={"small"}>*/}
                {/*        <TableRow>*/}
                {/*            <TableCell>Abrechnungsart:</TableCell>*/}
                {/*            <TableCell><strong>Monatlich</strong></TableCell>*/}
                {/*        </TableRow>*/}
                {/*        <TableRow>*/}
                {/*            <TableCell>Nächste Abbuchung:</TableCell>*/}
                {/*            <TableCell>26.10.2025</TableCell>*/}
                {/*        </TableRow>*/}
                {/*        <TableRow>*/}
                {/*            <TableCell>Betrag:</TableCell>*/}
                {/*            <TableCell>29 € zzgl. Ust</TableCell>*/}
                {/*        </TableRow>*/}
                {/*    </Table>*/}
                {/*</TableContainer>*/}

                {subscription
                    ? <CurrentSubscription subscription={subscription} creemActive={creemActive ?? false}/>
                    : <WarningBox>Kein gültiges Abo vorhanden!</WarningBox>}

                {isRegistryMember ? <InfoBox>Die Abrechnung erfolgt über den Zuchtverband</InfoBox> : null}

                {showPastDue ? <Alert severity="warning">{t('subscription.pastDue.message')}</Alert> : null}

                {showCustomerPortal ? <CustomerPortalButton/> : null}


                {/*<Stack direction="row" gap={2}>*/}
                {/*    <Button variant="contained" startIcon={<SwapHoriz/>} onClick={changeSubscription}>Abrechnung ändern</Button>*/}
                {/*    <Button variant="outlined" startIcon={<CreditCard/>} onClick={changePaymentMode}>Zahlungsmittel ändern</Button>*/}
                {/*    <Button variant="outlined" startIcon={<Cancel/>} color="error" onClick={cancelSubscription}>Abo kündigen</Button>*/}
                {/*</Stack>*/}
            </FlexWidget>

            {canResumeCheckout({isRegistryMember, subscription, creemActive}) ? (
                <FlexWidget displayName={t('subscription.resumeCheckout.title')}>
                    <ResumeCheckout trial={isTrialResume}/>
                </FlexWidget>
            ) : null}

            {/*<InvoiceWidget/>*/}

            {/*<FlexWidget displayName="Abrechnung ändern">*/}
            {/*    <InfoBox>Coming soon.</InfoBox>*/}
            {/*</FlexWidget>*/}

            {/*<SubscriptionTestingWidget/>*/}

        </FlexStack>
    );
};